"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M9 5.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5zm0 4a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.655 5.445a.15.15 0 0 0-.15.15v.364c0 .082.067.15.15.15h5.795a.15.15 0 0 0 .15-.15v-.364a.15.15 0 0 0-.15-.15zm-1.55.15c0-.856.694-1.55 1.55-1.55h5.795c.856 0 1.55.694 1.55 1.55v.364a1.55 1.55 0 0 1-1.55 1.55H9.655a1.55 1.55 0 0 1-1.55-1.55zM6.736 4.434a.7.7 0 0 1 .002.99L5.162 7.005a.7.7 0 0 1-.992 0l-.966-.97a.7.7 0 0 1 .992-.987l.47.471 1.08-1.084a.7.7 0 0 1 .99-.001m2.92 5.248a.15.15 0 0 0-.15.15v.363c0 .083.066.15.15.15h5.794a.15.15 0 0 0 .15-.15v-.363a.15.15 0 0 0-.15-.15zm-1.55.15c0-.856.693-1.55 1.55-1.55h5.794c.856 0 1.55.694 1.55 1.55v.363a1.55 1.55 0 0 1-1.55 1.55H9.655a1.55 1.55 0 0 1-1.55-1.55zM6.735 8.67a.7.7 0 0 1 .002.99l-1.576 1.582a.7.7 0 0 1-.992 0l-.966-.97a.7.7 0 0 1 .992-.988l.47.472 1.08-1.084a.7.7 0 0 1 .99-.002m2.92 5.221a.15.15 0 0 0-.15.15v.364c0 .083.066.15.15.15h5.794a.15.15 0 0 0 .15-.15v-.364a.15.15 0 0 0-.15-.15zm-1.55.15c0-.856.693-1.55 1.55-1.55h5.794c.856 0 1.55.694 1.55 1.55v.364a1.55 1.55 0 0 1-1.55 1.55H9.655a1.55 1.55 0 0 1-1.55-1.55zm-1.37-1.161a.7.7 0 0 1 .002.99l-1.575 1.58a.7.7 0 0 1-.992 0l-.966-.969a.7.7 0 1 1 .992-.988l.47.472 1.08-1.084a.7.7 0 0 1 .99-.002",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=TaskListIcon20.js.map